import {Route, Routes, Outlet, Navigate,Link, useNavigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {ClinicListWrapper} from './employee-support-list/ClinicList'
 

import { ViewClinicSupport } from './employee-support-form/ViewClientupport'
import { AlertContext } from '../../../../../_metronic/layout/components/alert-context'
import { useContext, useEffect } from 'react'

const clinicBreadcrumbs: Array<PageLink> = [
  {
    title: 'Worker Support',
    path: '/agencyWorkerSupport',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const EmployeeClientsupportPage = () => {
  const { hideAlert } = useContext(AlertContext);
  useEffect(() => {
    hideAlert(false);
  }, []);
  const navigate = useNavigate();
  function goBack() {
    navigate(-1);
  }
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <PageTitle breadcrumbs={clinicBreadcrumbs}>Worker Support</PageTitle>
               
              <ClinicListWrapper />
            </>
          }
        />
        
        <Route
          path='/view/:id'
          element={
            <>
              <PageTitle breadcrumbs={clinicBreadcrumbs}>View Support</PageTitle>
              <button onClick={goBack} style={{marginBottom:"15px"}}  className='btn btn-sm btn-info px-6 align-self-center text-nowrap'> 
           <i className="bi bi-reply fs-4 me-2"></i> Go Back </button> 
              <ViewClinicSupport />
            </>
          }
        />
         
        <Route index element={<Navigate to='list' />} />
      </Route>
    </Routes>
  )
}

export default EmployeeClientsupportPage
